import React, { useState } from "react";
import Layout from "../../../Components/Layout";
import AssignGuard from "../../../Components/OrderMgt/Guard/AssignGuard";

const AssignGuardPage = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Layout
      Heading="Assign Guard"
      TitleMark={true}
      TitleMarkClassName="event-guard-title-mark"
      TitleClassName="event-guard-title"
      HeadClassName="event-guard-head"
      ExtraclassName="event-guard-panel"
      activeMenuId="assign-guard"
      extraElement={
        <button
          className="event-guard-header-btn"
          type="button"
          onClick={() => setIsOpen(true)}
        >
          <i className="bi bi-plus-lg" aria-hidden="true"></i> Add Guard
        </button>
      }
    >
      <AssignGuard isOpen={isOpen} setIsOpen={setIsOpen} />
    </Layout>
  );
};

export default AssignGuardPage;
